<script setup lang="ts">
import { formatDate, type Locale } from '@taler/domain'
import type { ReconciliationSummary } from '../internal/types.ts'
import { StatusTag } from '@taler/ui'
import { useI18n } from 'vue-i18n'

defineProps<{
  summaries: readonly ReconciliationSummary[]
  locale: Locale
}>()

const { t } = useI18n()
</script>

<template>
  <table class="w-full border-collapse text-[length:var(--text-step-2)]">
    <thead>
      <tr class="table-head">
        <th class="px-[var(--space-cell)] py-[var(--space-inline)]">
          {{ t('reconciliation.history.date') }}
        </th>
        <th class="px-[var(--space-cell)] py-[var(--space-inline)]">
          {{ t('reconciliation.history.status') }}
        </th>
        <th class="px-[var(--space-cell)] py-[var(--space-inline)]">
          {{ t('reconciliation.history.checked') }}
        </th>
        <th class="px-[var(--space-cell)] py-[var(--space-inline)]">
          {{ t('reconciliation.history.corrected') }}
        </th>
        <th class="px-[var(--space-cell)] py-[var(--space-inline)]">
          {{ t('reconciliation.history.transfers') }}
        </th>
        <th class="px-[var(--space-cell)] py-[var(--space-inline)]"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="summary in summaries"
        :key="summary.id"
        class="border-b border-[color:var(--color-border)] text-[color:var(--color-text)]"
      >
        <td class="px-[var(--space-cell)] py-[var(--space-inline)]">
          {{ formatDate(summary.observedDate, locale) }}
        </td>
        <td class="px-[var(--space-cell)] py-[var(--space-inline)]">
          <StatusTag v-if="summary.status === 'FINISHED'" tone="ok">
            {{ t('reconciliation.history.finished') }}
          </StatusTag>
          <StatusTag v-else tone="wait">{{ t('reconciliation.history.open') }}</StatusTag>
        </td>
        <td class="px-[var(--space-cell)] py-[var(--space-inline)] tabular-nums">
          {{ summary.accountsChecked }}
        </td>
        <td class="px-[var(--space-cell)] py-[var(--space-inline)] tabular-nums">
          {{ summary.accountsCorrected }}
        </td>
        <td class="px-[var(--space-cell)] py-[var(--space-inline)] tabular-nums">
          {{ summary.reallocationCount }}
        </td>
        <td class="px-[var(--space-cell)] py-[var(--space-inline)] text-right">
          <RouterLink
            :to="{ name: 'reconciliation', params: { id: summary.id } }"
            class="text-[color:var(--color-accent)] underline"
          >
            {{ t('reconciliation.history.view') }}
          </RouterLink>
        </td>
      </tr>
    </tbody>
  </table>
</template>
